import React, { MutableRefObject, useCallback, useRef, useState } from "react";
import { Form, Select, SubmitButton } from "formik-antd";
import { Spin } from "antd";
import { Formik, FormikErrors, FormikValues } from "formik";
import * as Yup from "yup";
import { AccountType } from "../../../../../types/user";

const { Option, OptGroup } = Select;
export interface ITicketGroupAddMembersFormProps {
  isLoading: boolean;
  members: any[];
  users: any[];
  onSave: (
    values: ITicketGroupAddMembersFormValues,
    onRequestComplete: () => void,
    setError: (errors: FormikErrors<ITicketGroupAddMembersFormValues>) => void
  ) => void;
}

export interface ITicketGroupAddMember {
  label: string;
  value: number;
  key: number;
}
export interface ITicketGroupAddMembersFormValues {
  members: ITicketGroupAddMember[];
}

const TicketGroupAddMembersForm = (props: ITicketGroupAddMembersFormProps) => {
  const { users, members, isLoading, onSave } = props;

  const initialFormValues: ITicketGroupAddMembersFormValues = {
    members: [],
  };
  const [formData, setFormData] = useState<ITicketGroupAddMembersFormValues>(
    initialFormValues
  );

  const [editRequest, setEditRequest] = useState<boolean>(false);

  const formikRef = useRef<FormikValues>();

  const FormSchema = Yup.object().shape({
    members: Yup.array()
      .min(1, "Wybierz przynajmniej jedną osobę.")
      .required("Pole wymagane"),
  });

  const groupedUsers = users.reduce((groups, user) => {
    if (!members.some((member: any) => member.user.id === user.id)) {
      const group = groups[user.typeAccount] || [];
      group.push(user);
      // eslint-disable-next-line no-param-reassign
      groups[user.typeAccount] = group;
    }
    return groups;
  }, []);

  const filterOption = useCallback((search, optionOrGroup) => {
    const isGroup = Array.isArray(optionOrGroup.options);
    if (isGroup) {
      return false;
    }
    return optionOrGroup.children.toLowerCase().includes(search.toLowerCase());
  }, []);

  return (
    <Spin spinning={isLoading}>
      <Formik
        innerRef={formikRef as MutableRefObject<any>}
        initialValues={formData}
        enableReinitialize
        validationSchema={FormSchema}
        onSubmit={(
          values: ITicketGroupAddMembersFormValues,
          { resetForm, setErrors }
        ) => {
          setEditRequest(true);
          onSave(
            values,
            () => {
              setEditRequest(false);
              resetForm();
            },
            setErrors
          );
        }}
        validateOnChange
        render={() => (
          <Form style={{ marginTop: 16 }}>
            <Form.Item
              name="members"
              className="show-label"
              label="Wybierz osoby do przydzielenia"
              labelCol={{ span: 24 }}
            >
              <Select
                name="members"
                labelInValue
                showSearch
                placeholder="Wybierz lub wyszukaj"
                optionFilterProp="children"
                mode="multiple"
                filterOption={filterOption}
              >
                {groupedUsers.map((group: any, index: number) => (
                  <OptGroup label={AccountType[index]}>
                    {group.map((user: any) => {
                      const optionLabel = `${user.name} ${user.surname} (${user.email})`;
                      return <Option value={user.id}>{optionLabel}</Option>;
                    })}
                  </OptGroup>
                ))}
              </Select>
            </Form.Item>
            <SubmitButton loading={editRequest}>Dodaj</SubmitButton>
          </Form>
        )}
      />
    </Spin>
  );
};

export default TicketGroupAddMembersForm;
